import { IonItem } from "@ionic/react";
import React from "react";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

interface PositionsListItemProps {
  data: any;
}

const PositionsListItem: React.FC<PositionsListItemProps> = ({ data }) => {
  const { cc, d, g, gs, ab, asp, p, l, netPos, pnl } = data;

  return (
    <IonItem
      detail={false}
      className="ion-no-padding animate__animated animate__fadeIn"
      lines="none"
      style={{
        "--inner-padding-end": 0,
        "--min-height": "70px",
        "--background": "#112B4A",
        marginBottom: "2px",
      }}
    >
      <div className="custom_positionsgrid_item">
        <div className="pg__contract_netpos_section">
          <div className="pg__contract_sub-section">{cc + " " + d}</div>
          <div
            className={`pg__netpos_sub-section ${
              netPos?.isZero()
                ? ""
                : netPos?.isPositive()
                  ? "netpos_positive"
                  : "netpos_negative"
            }`}
          >
            {netPos?.toNumber()?.toLocaleString()}
          </div>
        </div>
        <div className="pg__buyqty_sellqty_section">
          <div className="pg__buyqty_sub-section">{g?.f}</div>
          <div className="pg__sellqty_sub-section">{gs?.f}</div>
        </div>
        <div className="pg__avgbuy_avgsell_section">
          <div className="pg__avgbuy_sub-section">{ab?.f}</div>
          <div className="pg__avgsell_sub-section">{asp?.f}</div>
        </div>
        <div className="pg__refprice_pnl_section">
          <div className="pg__refprice_sub-section">{l?.f}</div>
          <div
            className={`pg__pnl_sub-section ${
              pnl?.isZero()
                ? ""
                : pnl?.isPositive()
                  ? "pnl_positive"
                  : "pnl_negative"
            }`}
          >
            {pnl?.toNumber()?.toLocaleString()}
          </div>
        </div>
      </div>
    </IonItem>
  );
};

export default PositionsListItem;
